export const LISTING_ID_NOT_FOUND = '查無編號，請重新確認'

export const NOT_FOUND = '目前沒有資料'
